import { StyleSheet, css } from 'aphrodite';
import { PropTypes } from 'prop-types';
import React, { Component } from 'react';
import Isvg from 'react-inlinesvg';
import ReactSelect from 'react-select';
import { Theme } from '../../config/theme';

import './select.css';

let styles;
const ARROW_ASSET = require('./arrow.svg');

export default class Select extends Component {
  constructor(props) {
    super(props);
    this.updateValue = this.updateValue.bind(this);
    this.open = this.open.bind(this);
    this.close = this.close.bind(this);
    this.valueRenderer = this.valueRenderer.bind(this);

    this.initialLabel = this.props.options[0] ? this.props.options[0].label : null;

    this.state = {
      selectOpen: false,
      selectValue: null,
      totalSelected: 0,
      singleValue: null,
    };
  }

  updateValue(newValue) {
    this.props.handler(this.props.name, newValue);
    this.setState({
      selectValue: newValue,
      singleValue:
        newValue && typeof newValue === 'object' && newValue[0] ? newValue[0].label : null,
      totalSelected: newValue && newValue.length,
    });
  }

  open() {
    if (this.props.disabled) {
      return;
    }
    this.setState({
      selectOpen: !this.state.selectOpen,
    });
  }

  close() {
    this.setState({
      selectOpen: !this.state.selectOpen,
    });
  }

  valueRenderer(res) {
    this.fish = null;

    return <div className="Select-value">{res.value.label}</div>;
  }

  render() {
    let ICON_ASSET;
    let multiLabel;

    if (this.props.type !== 'simple') {
      ICON_ASSET = require(`./icons/${this.props.type}.svg`); // eslint-disable-line
    }

    if (this.state.totalSelected > 1) {
      multiLabel = `${this.props.multiLabel} (${this.state.totalSelected})`;
    } else if (this.state.totalSelected === 1) {
      multiLabel = this.state.singleValue;
    }

    return (
      <div className={css(styles.select_container)}>
        {this.props.label ? (
          <label htmlFor={this.props.name} className={css(styles.label)}>
            {this.props.label}
          </label>
        ) : null}
        <div className={css(styles.select_parent)}>
          {this.props.disabled && <div className={css(styles.disabled_overlay)} />}
          <ReactSelect
            name={this.props.name}
            value={this.props.value ? this.props.value : null}
            placeholder={this.props.placeholder}
            options={this.props.options}
            clearable
            backspaceRemoves={false}
            onChange={this.updateValue}
            onOpen={this.open}
            onClose={this.close}
            className={css(styles.select, this.props.style)}
            multi={this.props.multiLabel !== null}
            valueComponent={this.valueRenderer}
            noOptionsMessage={this.props.noOptionsMessage}
            closeOnSelect={!this.props.multiLabel}
            disabled={this.props.disabled}
          />
          <Isvg
            cacheGetRequests
            src={ICON_ASSET}
            className={
              this.state.selectOpen || (this.props.value && this.props.value.length)
                ? css(styles.select_icon, styles.select_icon_open)
                : css(styles.select_icon)
            }
          />
          <Isvg
            cacheGetRequests
            src={ARROW_ASSET}
            className={
              this.state.selectOpen === true
                ? css(styles.select_arrow, styles.select_arrow_open)
                : css(styles.select_arrow)
            }
          />
          {this.props.multiLabel ? (
            <div className={css(styles.multi_label)}>
              {multiLabel ? (
                multiLabel // eslint-disable-line
              ) : (
                <span className={css(styles.placeholder)}>All {this.props.multiLabel}</span>
              )}
            </div>
          ) : null}
        </div>
      </div>
    );
  }
}

Select.defaultProps = {
  multiLabel: null,
  label: null,
  handler: () => {},
  value: null,
  style: false,
  noOptionsMessage: 'No results found',
  disabled: false,
};

Select.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string,
  style: PropTypes.object,
  placeholder: PropTypes.string.isRequired,
  options: PropTypes.arrayOf(PropTypes.object).isRequired,
  type: PropTypes.string.isRequired,
  multiLabel: PropTypes.string,
  handler: PropTypes.func,
  value: PropTypes.oneOf([PropTypes.string, PropTypes.number]),
  noOptionsMessage: PropTypes.string,
  disabled: PropTypes.bool,
};

styles = StyleSheet.create({
  multi_label: {
    position: 'absolute',
    top: 1,
    left: 51,
    zIndex: 1,
    display: 'flex',
    alignItems: 'center',
    height: 48,
    width: 130,
    fontFamily: Theme.font_family_primary,
    fontSize: 15,
    color: '#000e1f',
    backgroundColor: Theme.white,
    pointerEvents: 'none',
    transition: 'all 300ms',

    [Theme.mobile_query]: {
      display: 'none',
    },
  },
  label: {
    display: 'block',
    marginBottom: 9,
    fontFamily: Theme.font_family_primary,
    fontWeight: Theme.font_weight_primary,
    fontSize: 14,
    color: '#828282',
  },
  select: {
    position: 'relative',
  },
  select_parent: {
    position: 'relative',
  },
  select_container: {
    position: 'relative',

    [Theme.mobile_query]: {
      ':not(.a) > div': {
        width: '100%',
      },

      ':not(.a) > div.is-open .Select-input > input': {
        width: '100%',
      },

      ':not(.a) > div.is-open': {
        zIndex: 9,
      },
    },
  },
  select_icon: {
    position: 'absolute',
    top: 0,
    left: 0,
    zIndex: 2,
    display: 'block',
    height: 50,
    width: 50,
    pointerEvents: 'none',
    fill: '#D0D0D0',
    transition: 'fill 300ms',
  },
  select_icon_open: {
    fill: Theme.primary,
  },
  select_arrow: {
    position: 'absolute',
    top: 0,
    right: 20,
    zIndex: 2,
    display: 'flex',
    alignItems: 'center',
    height: 50,
    width: 9,
    pointerEvents: 'none',
    transition: 'all 300ms',
  },
  select_arrow_open: {
    transform: 'rotateX(180deg)',
  },
  placeholder: {
    color: '#828282',
    transition: 'color 300ms',
  },
  disabled_overlay: {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    backgroundColor: 'transparent',
    zIndex: 10,
    cursor: 'not-allowed',
  },
});



// WEBPACK FOOTER //
// ./src/components/Select/index.js